import { useEffect, useState } from 'react';
import { useGetStandardsListQuery, useLazyGetStandardTopicsListQuery } from 'store/slices/standards/apis/standardsApi';

import type { IStandard } from 'pages/MaterialAssessmentPages/MaterialityAssessmentInitial/interfaces/IStandard';

const useGetCurrentStandards = () => {
  const [standardOptions, setStandardOptions] = useState<IStandard[]>([]);
  const [actualStandardOptions, setActualStandardOptions] = useState<IStandard[]>([]);

  const { data: standards, isFetching: isFetchingStandards } = useGetStandardsListQuery({
    offset: 0,
  });

  const [getTopicsList] = useLazyGetStandardTopicsListQuery();

  useEffect(() => {
    if (standards && standards.data.items.length > 0) {
      const options = standards.data.items.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setStandardOptions(options);
    }
  }, [standards, setStandardOptions]);

  useEffect(() => {
    if (standards && standards.data.items.length > 0) {
      const options: IStandard[] = [];
      standards?.data?.items.forEach(async (standard) => {
        const topicsResponse = await getTopicsList({ standardId: standard.id, offset: 0 }).unwrap();
        if (topicsResponse && topicsResponse.data.items.length > 0) {
          options.push({
            value: standard.id,
            label: standard.name,
          });
        }
      });
      setActualStandardOptions(options);
    }
  }, [standards, getTopicsList]);

  return {
    standards, standardOptions, actualStandardOptions, isFetchingStandards,
  };
};

export default useGetCurrentStandards;
